<div>
  @switch (viewMode) {
    <!-- Medicare Verbose View -->
    @case ('showVerbose') {
      <section>
        <h2 class="verboseHeader">
          Available {{ yearSelected }} Plans for {{ countyInfo.zipCode || 'ZIP'}} in {{ countyInfo.county?.county ||
          'COUNTY' }} County.
          @if (!hideEditButtonBool) {
            <span class="changeZipYear"><a class="verbose" href="javascript:void(0)"
            (click)="setZipCounty()">(EDIT)</a></span>
          }
        </h2>
        <p>
          <span class="material-symbols-outlined warningIcon">warning</span> {{ verboseSubHeader ||"To enroll in any of the plans, you must
          be eligible for Medicare and already enrolled in
          both Part A and Part B."}}
        </p>
      </section>
    }
    <!-- Medicare Compact Details View -->
    @case ('showCompact') {
      <section class="zip-alert mat-typography mat-body mat-app-background ">
        <div class="zipbox">
          <div class="current-description">
            <div>{{ yearSelected }} <span> (Plan Year)</span></div>
          </div>
          @if (isMultiBrandASP()) {
            <div class="current-description">
              <div> {{ countyInfo.zipCode || 'ZIP'}}<span> (Zip Code) </span></div>
              <div> {{ countyInfo.county?.county || 'COUNTY' }}<span> (County) </span></div>
              <div>{{ countyInfo.county?.state || 'STATE' }}<span> (State)</span></div>
            </div>
            }
          </div>
          <div class="current-description">
            <div>
              Effective Date: <a href="javascript:void(0)" (click)="setZipCounty()">{{displayEffectiveDate ||
            'MM/DD/YYYY'}}</a>
          </div>
          <div>
            Coverage for: <a href="javascript:void(0)" (click)="setZipCounty()">{{yearSelected || 'YEAR'}}</a>
          </div>
        </div>
        @if (!hideEditButtonBool) {
          <div class="changeZipYear">
            <a href="javascript:void(0)" (click)="setZipCounty()">CHANGE AREA</a>
          </div>
        }
      </section>
    }
    <!-- Individual Verbose View -->
    @case ('individualVerbose') {
      <section>
        <h2 class="verboseHeader">
          View {{ yearSelected }} Plans for {{ countyInfo.zipCode || 'ZIP'}} in {{ countyInfo.county?.county || 'COUNTY' }}
          County.
          @if (!hideEditButtonBool) {
            <span class="changeZipYear"><a class="verbose" href="javascript:void(0)"
            (click)="openZipModal(true)">(CHANGE)</a>
          </span>
        }
      </h2>
      <p>
        Need to change your eligibility or family details?
        <a href="{{redirectClosedUrl}}"> Let's review and edit your information.</a>
      </p>
      @if (verboseSubHeader) {
        <p>
          <span class="material-symbols-outlined warningIcon">warning</span> {{ verboseSubHeader || "Tooltip" }}
        </p>
      }
    </section>
  }
  <!-- Individual Compact Details View -->
  @case ('individualCompact') {
    <section
      class="responWidth zip-alert mat-typography mat-body mat-app-background ">
      <div class="">
        <div class="current-description rightAlign boldCompact">
          <div>{{ countyInfo.county?.county || 'COUNTY' }} COUNTY, {{ countyInfo.county?.state || 'STATE' }} {{
          countyInfo.zipCode || 'ZIP'}}</div>
        </div>
        @if (!hideEditButtonBool) {
          <div class="changeZipYear rightAlign">
            <a href="javascript:void(0)" (click)="openZipModal()">CHANGE AREA</a>
          </div>
        }
      </div>
    </section>
  }
  <!-- Buttons View -->
  @default {
    <section>
      @if (buttonStyle === 'primary' || !buttonStyle) {
        <button class="home-shop-plans-button" id="shop-plans-button"
          mat-raised-button color="primary" (click)="setZipCounty()">
          <span>
            <slot name="button-label">View Plans by Zipcode</slot>
          </span>
        </button>
      }
      @if (buttonStyle === 'link') {
        <button id="shop-plans-button" class="link-button" mat-flat-button color="link"
          (click)="setZipCounty()">
          <span>
            <slot name="button-label">View Plans by Zipcode</slot>
          </span>
        </button>
      }
      @if (buttonStyle === 'accent') {
        <button id="shop-plans-button" mat-raised-button color="accent"
          (click)="setZipCounty()">
          <span>
            <slot name="button-label">View Plans by Zipcode</slot>
          </span>
        </button>
      }
    </section>
  }
}
</div>